import { useFlags } from "launchdarkly-react-client-sdk";
import { Navigate, useLocation } from "react-router-dom";
// import { isSessionAuthenticated } from "@/services/auth";

// Allow these routes even when under maintenance:
const PUBLIC_ALLOWED = ["/signin", "/logout", "/signup", "/oauth/redirect", "/maintenance"];

export const MaintenanceGuard = ({ children }: any) => {
  const { maintenanceMode } = useFlags();   // LD flag

  // const isLoggedIn = await isSessionAuthenticated();
  const location = useLocation();

  if (!maintenanceMode) return children;

  // If on the allowed routes → do nothing
  if (PUBLIC_ALLOWED.some((path) => location.pathname.startsWith(path))) {
    return children;
  }

  // // If user is authenticated + Maintenance is ON → redirect
  // if (isAuthenticated) {
  //   return <Navigate to="/maintenance" replace />;
  // }

  // return children;

  return <Navigate to="/maintenance" replace />;
};
